import { Controller } from "@hotwired/stimulus"

const DEBOUNCE_MS = 250

// Connects to data-controller="admin--pod-embed-picker"
export default class extends Controller {
  static targets = ["query", "select"]
  static values = {
    endpointUrl: String
  }

  connect() {
    this.searchTimeout = null
  }

  disconnect() {
    if (this.searchTimeout) {
      window.clearTimeout(this.searchTimeout)
      this.searchTimeout = null
    }
  }

  search() {
    if (!this.hasEndpointUrlValue || !this.hasSelectTarget || !this.hasQueryTarget) return

    if (this.searchTimeout) window.clearTimeout(this.searchTimeout)
    this.searchTimeout = window.setTimeout(() => {
      this.fetchAndRender(this.queryTarget.value)
    }, DEBOUNCE_MS)
  }

  async fetchAndRender(rawQuery) {
    const query = (rawQuery || "").trim()
    const url = new URL(this.endpointUrlValue, window.location.origin)
    if (query.length > 0) url.searchParams.set("q", query)

    const currentValue = this.selectTarget.value

    try {
      const response = await window.fetch(url.toString(), {
        headers: {
          Accept: "application/json"
        },
        credentials: "same-origin"
      })
      if (!response.ok) return

      const payload = await response.json()
      const groups = Array.isArray(payload?.groups) ? payload.groups : []
      this.replaceOptions({ groups, currentValue })
    } catch (_error) {
      // Keep existing options if search fetch fails.
    }
  }

  replaceOptions({ groups, currentValue }) {
    const blankOption = this.selectTarget.querySelector("option[value='']")
    const blankLabel = blankOption ? blankOption.textContent : "Select option"

    this.selectTarget.innerHTML = ""
    this.selectTarget.appendChild(new Option(blankLabel, ""))

    groups.forEach((group) => {
      const options = Array.isArray(group?.options) ? group.options : []
      if (options.length === 0) return

      const optgroup = document.createElement("optgroup")
      optgroup.label = group.label || "Options"

      options.forEach((option) => {
        const value = option?.value || ""
        const label = option?.label || value
        optgroup.appendChild(new Option(label, value))
      })

      this.selectTarget.appendChild(optgroup)
    })

    const optionValues = Array.from(this.selectTarget.options).map((option) => option.value)
    this.selectTarget.value = optionValues.includes(currentValue) ? currentValue : ""
  }
}
